module.exports = __webpack_public_path__ + "images/media_kits/treedom_certificate_ck.e86921c4528e30732f40d2863d85f9f2.jpg";